/**
 * @module xwb/validator
 * @author Guschin Mikhail <misha@arkcom.ru>
 * @version 0.1.0
 * @description
 * # Валидаторы типов данных
 */

export * from './numbers';